<!--------- Footer area start --------->
<footer class="gm-footer">
	<div class="container">
		<div class="gm-footer__inner">
			<div class="gm-footer__brand">
				<a class="gm-footer__logo" routerLink="/" aria-label="Gigmor">
					<img src="assets/img/logo.svg" alt="Gigmor" />
				</a>
				<div class="gm-footer__socials">
					<a class="gm-footer__social" target="_blank" href="https://instagram.com/gigmor/" aria-label="Instagram"><img src="assets/icons/instagram-2.svg" alt="Instagram" /></a>
					<a class="gm-footer__social" target="_blank" href="https://www.threads.net/@gigmor" aria-label="Threads"><img src="assets/icons/threads.svg" alt="Threads" /></a>
					<a class="gm-footer__social" target="_blank" href="https://www.facebook.com/gigmor" aria-label="Facebook"><img src="assets/icons/facebook.svg" alt="Facebook" /></a>
					<a class="gm-footer__social" target="_blank" href="https://www.youtube.com/c/Gigmor" aria-label="YouTube"><img src="assets/icons/youtube-2.svg" alt="YouTube" /></a>
					<a class="gm-footer__social" target="_blank" href="https://open.spotify.com/user/h7wrmzkc0buxojnssqajz5ymh?si=dc9424ad6c144c83" aria-label="Spotify"><img src="assets/icons/spotify-3.svg" alt="Spotify" /></a>
				</div>
				<p class="gm-footer__copyright">Gigmor &copy;2026 All Rights Reserved.</p>
			</div>

			<nav class="gm-footer__links">
				<div class="gm-footer__col">
					<a class="gm-footer__link gm-footer__link--active" (click)="openPage('gigfunders')">GigFunders</a>
					<a class="gm-footer__link" (click)="openPage('artist')">Artists</a>
					<a class="gm-footer__link" (click)="openPage('shows')">Shows</a>
				</div>
				<div class="gm-footer__col">
					<a class="gm-footer__link" routerLink="/about">About</a>
					<a class="gm-footer__link" routerLink="/faq">FAQ</a>
					<a class="gm-footer__link" routerLink="/contact">Support</a>
					<a class="gm-footer__link" routerLink="/contact">Contact</a>
				</div>
				<div class="gm-footer__col">
					<a class="gm-footer__link" routerLink="/terms">Terms</a>
					<a class="gm-footer__link" routerLink="/privacy">Privacy</a>
				</div>
			</nav>

			<div class="gm-footer__apps">
				<h4 class="gm-footer__app-title">Get the App</h4>
				<a class="gm-footer__app" target="_blank" href="https://apps.apple.com/us/app/gigmor/id1639391211"><img src="assets/img/app_store.png" alt="Download on the App Store" /></a>
				<a class="gm-footer__app" target="_blank" href="https://play.google.com/store/apps/details?id=com.gigmor"><img src="assets/img/google_play.png" alt="Get it on Google Play" /></a>
			</div>
		</div>
	</div>
</footer>
<!--------- Footer area end --------->

<!--------- Mobile app popup start --------->
<div *ngIf="showPopup">
	<div class="overlay"></div>
	<div class="center-popup">
		<!-- <button type="button" class="popup-back" (click)="showPopup = false" aria-label="Back">
			<img src="assets/img/back-button.svg" alt="" />
			<span>Back</span>
		</button> -->
		<div class="phone-device ios" [ngClass]="getDynamicClass()">
			<figure style="margin: 0 auto"><iframe scrolling="no" importance="high" allow="payment" [src]="iframeURL | safe : 'resourceUrl'"></iframe></figure>
		</div>
	</div>
</div>
<!--------- Mobile app popup end --------->
